import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import cn from "classnames";
import { Link } from "react-scroll";
import { Player } from "video-react";
import { NavContext, showedNav } from "../../context/NavState";
import { IMedia, IService } from "../../types";
import { ApiData } from "../../api";
import { media } from "../../utils/StrapiUtils";

const ServiceItem = (
  el: IService & {
    setHeight?: Dispatch<SetStateAction<Record<string, number>>>;
  },
) => {
  const getImage = (image: IMedia) => {
    if (!image) return <div></div>;
    const links = media(el.image);
    if (!links) return <div></div>;
    return /(mp4|mov|avi|mkv|flv)/gm.test(image.ext) ? (
      <Player playsInline src={links.src} />
    ) : (
      <img src={links.src} alt={links.alt} className="serviceImg" />
    );
  };

  const ref = useRef<HTMLDivElement>();

  const resizeHandler = () => {
    if (ref.current?.scrollHeight) {
      el.setHeight((h) => ({
        ...h,
        [el.name]: ref.current?.scrollHeight + 20,
      }));
    }
  };

  React.useEffect(() => {
    if (el.setHeight) {
      window.addEventListener("resize", resizeHandler);
      resizeHandler();
      return () => {
        window.removeEventListener("resize", resizeHandler);
      };
    }
  }, []);
  return (
    <div ref={ref} className="serviceItem">
      <div className="serviceImgBlock">{el.image && getImage(el.image)}</div>
      <div className="serviceText">
        <div className="serviceTextInner">
          <h5>{el.name}</h5>
          <p>{el.description}</p>
        </div>
      </div>
    </div>
  );
};

const Services = () => {
  const [hidden, setHidden] = useState(true);
  const { origNavigation, setNavigationContext } = useContext(NavContext);
  const [servicesData, setServicesData] = useState<IService[]>([]);
  const cln = (name) => cn({ [name + "Hidden"]: hidden, [name]: !hidden });
  const btnClick = () => {
    setHidden(!hidden);
  };
  useEffect(() => {
    ApiData.services().then((res) => {
      const services = res.sort((a, b) => (a.sort > b.sort ? 1 : -1));
      if (!services?.length) return;
      setServicesData(services);
      showedNav.add("services");
      setNavigationContext(origNavigation.filter((el) => showedNav.has(el.to)));
    });
  }, []);

  const [blockHeight, setBlockHeight] = useState({} as Record<string, number>);
  return servicesData.length ? (
    <>
      <div id="services" className="blockContent" style={{ zIndex: 1 }}>
        <div
          className={cln("serviceMainBlock")}
          style={{
            height: hidden
              ? 1100
              : Object.values(blockHeight).reduce((a, b) => a + b, 130),
          }}
        >
          <div className={cn({ serviceBlockHidden: hidden })}>
            <h2 className="titles">Наши услуги</h2>
            {servicesData.map((el) => (
              <ServiceItem setHeight={setBlockHeight} {...el} key={el.id} />
            ))}
          </div>
        </div>
      </div>
      {servicesData.length > 4 ? (
        <div className="blockContent">
          <div className="buttonService">
            <div className="serviceFadeEffect">
              <Link
                to={"serviceMainBlock"}
                onClick={btnClick}
                offset={300}
                className="serviceFadeEffectBtn"
                smooth={true}
                duration={1500}
              >
                {hidden ? "Все услуги" : "Скрыть"}
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  ) : (
    <></>
  );
};

export default Services;
